import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Icon from "module-common/Icon";

export default class LoadingPanel extends Component {
  static propTypes = {
    flex: PropTypes.number
  };
  static defaultProps = {
    flex: 1
  };

  render() {
    return (
      <Wrapper flex={this.props.flex}>
        <Icon name="loading-dots" width={100} />
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex: ${props => props.flex};
  align-items: center;
  justify-content: center;
`;



// WEBPACK FOOTER //
// ./src/module-common/LoadingPanel.js